import React from 'react';
import * as PropTypes from 'prop-types';

import getHeight from '../utils/getHeight';

const candleLeft = 'https://images.fallenlondon.com/css_img/candle01BG.png';
const candleRight = 'https://images.fallenlondon.com/css_img/candle02BG.png';

const candleTop = 'https://images.fallenlondon.com/css_img/candleTop.png';
const candleSnuffed = '//images.fallenlondon.com/css_img/candleSnuffed.png';

export default function Candle({ actions, right }) {
  const url = getBackgroundImageUrl({ actions, right });
  return (
    <div style={{
      background: `url(${url}) left bottom no-repeat`,
      bottom: '0',
      height: `${getHeight({ actions })}px`,
      width: '65px',
    }}
    >
      {actions > 0 && (
        <div style={{
          width: '65px',
          height: '75px',
          background: `url(${candleTop}) left top no-repeat`,
          marginTop: '-45px',
        }}
        />
      )}
    </div>
  );
}

Candle.displayName = 'Candle';

Candle.propTypes = {
  actions: PropTypes.number.isRequired,
  right: PropTypes.bool,
};

Candle.defaultProps = {
  right: false,
};

// Get the image we'll be using for the candle. If we have
// no actions, it's the snuffed candle; otherwise it's either the
// left or right candle
export function getBackgroundImageUrl({ actions, right }) {
  if (actions <= 0) {
    return candleSnuffed;
  }
  if (right) {
    return candleRight;
  }
  return candleLeft;
}